import { Routes } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';

export const routes: Routes = [
    {
        path: 'login',
        loadComponent: () => import('./pages/login/login').then(m => m.Login)
    },
    {
        path: 'emissao',
        loadComponent: () => import('./pages/emissao/emissao').then(m => m.Emissao),
        canActivate: [AuthGuard]
    },
    {
        path: 'emissao-duimp',
        loadComponent: () => import('./pages/emissao-duimp/emissao-duimp').then(m => m.EmissaoDuimp),
        canActivate: [AuthGuard]
    },
    {
        path: 'pagamentos',
        loadComponent: () => import('./pages/pagamentos/pagamentos').then(m => m.Pagamentos),
        canActivate: [AuthGuard]
    },
    {
        path: 'quarentena',
        loadComponent: () => import('./pages/quarentena/quarentena').then(m => m.Quarentena),
        canActivate: [AuthGuard]
    },
    {
        path: 'protocolo',
        loadComponent: () => import('./pages/protocolo/protocolo').then(m => m.Protocolo),
        canActivate: [AuthGuard]
    },
    {
        path: 'painel-recepcao',
        loadComponent: () => import('./pages/painel-recepcao/painel-recepcao')
            .then(m => m.PainelRecepcao),
        canActivate: [AuthGuard]
    },
    {
        path: 'validacao-arquivos',
        loadComponent: () => import('./pages/validacao-arquivos/validacao-arquivos')
            .then(m => m.ValidacaoArquivos),
        canActivate: [AuthGuard]
    },
    {
        path: 'parametros-recepcao',
        loadComponent: () => import('./pages/parametros-recepcao/parametros-recepcao')
            .then(m => m.ParametrosRecepcao),
        canActivate: [AuthGuard]
    },
    {
        path: 'rastreio-pagamento',
        loadComponent: () => import('./pages/rastreio-pagamento/rastreio-pagamento')
            .then(m => m.RastreioPagamentoPage),
        canActivate: [AuthGuard]
    },
    {
        path: 'dias-uteis',
        loadComponent: () => import('./pages/dias-uteis/dias-uteis').then(m => m.DiasUteis),
        canActivate: [AuthGuard]
    },
    {
        path: '**',
        redirectTo: 'emissao'
    }
];
